import { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { learningStatusCountRequest } from "../../../store/slices/selfSlice";
import { DoughnutChart } from "../../common/charts";
import Section from "../../common/section";

const ProgramStatusWidget = ({
  learningStatusCount,
  learningStatusCountRequest,
}) => {
  const intl = useIntl();
  const documentStyle = getComputedStyle(document.documentElement);

  useEffect(() => {
    learningStatusCountRequest();
  }, []);

  const programStatus = useMemo(() => {
    let counts = {};
    learningStatusCount.forEach((status) => {
      counts[status.status] = status.count;
    });

    return counts;
  }, [learningStatusCount]);

  return (
    <Section title="program_summary" className="edelxms-widget">
      <DoughnutChart
        data={{
          labels: [
            intl.formatMessage({
              id: "overdue",
            }),
            intl.formatMessage({
              id: "completed",
            }),
            intl.formatMessage({
              id: "inprogress",
            }),
            intl.formatMessage({
              id: "notstarted",
            }),
          ],
          datasets: [
            {
              data: [
                programStatus?.["OverDue"] || 0,
                programStatus?.["Completed"] || 0,
                (programStatus?.["Started"] || 0) +
                  (programStatus?.["InProgress"] || 0) +
                  (programStatus?.["InComplete"] || 0),
                programStatus?.["NotStarted"] || 0,
              ],
              backgroundColor: [
                documentStyle.getPropertyValue("--red-500"),
                documentStyle.getPropertyValue("--green-500"),
                "#0EA5E9",
                documentStyle.getPropertyValue("--orange-500"),
              ],
              hoverBackgroundColor: [
                documentStyle.getPropertyValue("--red-500"),
                documentStyle.getPropertyValue("--green-500"),
                "#0EA5E9",
                documentStyle.getPropertyValue("--orange-500"),
              ],
            },
          ],
        }}
      />
    </Section>
  );
};

const mapStateToProps = (state) => ({
  learningStatusCount: state.self?.summary?.learningStatusCount || [],
});

const mapDispatchToProps = (dispatch) => ({
  learningStatusCountRequest: () => dispatch(learningStatusCountRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgramStatusWidget);
